import React, {useState, useEffect, useContext} from 'react'
import { FirebaseContext } from '../../Services/firebase'

import { TextField, Button, Autocomplete, InputLabel, MenuItem, Select } from '@mui/material';

import DisplayChangeChoices from './DisplayChangeChoices';

import { getCustomerList } from '../../Utils/getCustomerList';

export default function ChangeCustomerChoice(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [value, setValue] = useState('clients');
    const [Week, setWeek] = useState('');
    const [Day, setDay] = useState('');
    const [Choices, setChoices] = useState([]);
    const [SelectChoice, setSelectChoice] = useState('');
    const [Open, setOpen] = useState(false);
    const [DayMenu, setDayMenu] = useState([]);

    const handleChange = (event) => {
        firebase.getCustomerChoices(props.UserSession.uid, value, Week, event.target.value).get()
        .then(querySnapshot => {
            querySnapshot.docs.forEach(doc => {
                setChoices(Choices => [...Choices, doc.id])
            })
        })
        setDay(event.target.value);
      };

    const handleActionCompleted = () => {
        setOpen(false);
        setWeek('');
        setDay('');
        setSelectChoice('');
        setChoices([]);
    };

    useEffect(() => {
            getCustomerList(firebase, props.UserSession.uid, setCustomers)
        }, [firebase, props.UserSession.uid])

    const checkChoices = (event) => {
        setWeek(event.target.value)
    }

    const handleOpenChoices = () => {
        const selectedChoiceRef = firebase.getSelectedChoice(
            props.UserSession.uid,
            value,
            Week,
            Day,
            SelectChoice
        );
        selectedChoiceRef.get().then((doc) => {
            setDayMenu(doc.data());
            setOpen(true);
        });
    };

    return (
        <div style={{display: "flex", flexDirection: "row"}}>
            <div style={{display: "flex", flexDirection: "column"}}>
                <Autocomplete
                    value={value || ''}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        setWeek('')
                        setDay('')
                        setChoices([])
                        setSelectChoice('')
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Customers}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="clients" />}
                />
                <div style={{display: "flex", flexDirection: "column", marginBottom: "1vh", marginTop: "2vh"}}>
                    <TextField required type="text" name="week" label="numéro de semaine" id="week" value={Week || ''} onChange={checkChoices} style={{width: "15vw"}} />
                    <InputLabel id="demo-simple-select-label">Jour</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="origin"
                        value={Day || ''}
                        label="Jour"
                        onChange={handleChange}
                        sx={{width: "10vw"}}
                    >
                        <MenuItem value={"1"}>lundi</MenuItem>
                        <MenuItem value={"2"}>mardi</MenuItem>
                        <MenuItem value={"3"}>mercredi</MenuItem>
                        <MenuItem value={"4"}>jeudi</MenuItem>
                        <MenuItem value={"5"}>vendredi</MenuItem>
                        <MenuItem value={"6"}>samedi</MenuItem>
                        <MenuItem value={"7"}>dimanche</MenuItem>
                    </Select>
                    <Autocomplete
                        value={SelectChoice || ''}
                        onChange={(event, newChoice) => {
                            setSelectChoice(newChoice);
                        }}
                        disablePortal
                        id="combo-box-demo"
                        options={Choices || ''}
                        sx={{ width: 300, marginTop: "1vh" }}
                        renderInput={(params) => <TextField {...params} label="menus" />}
                    />
                </div>
                <Button variant="outlined" onClick={handleOpenChoices}>Modifier</Button>
            </div>
            <div style={{marginLeft: "2vw"}}>
                {
                    Open === false ? null :
                    <DisplayChangeChoices content={DayMenu} uid={props.UserSession.uid} week={Week} customer={value} day={Day} choice={SelectChoice} onActionComplete={handleActionCompleted}/>
                }

            </div>
        </div>
    )
}